import React from "react";
import {
  Button,
  ButtonColour,
  ButtonSize,
  IButtonProps
} from "@trussle/external-components";

export const CTA: React.FC<IButtonProps> = ({ className, ...rest }) => (
  <Button
    id="heroff2-cta"
    colour={ButtonColour.DarkYellow}
    size={ButtonSize.Large}
    type="submit"
    {...rest}
    className={`heroff2-cta ${className}`}
  >
    {rest.children}
  </Button>
);
